import React from 'react';
import PropTypes from 'prop-types';

import { TileActionText } from './TileActionText';
import { CloseButton } from './TileActionButtons';

import { LeftButton } from './StyledComponents';

export const CampaignPreviewFormMenu = ({
  campaignContainer,
  postId,
  tileStatus,
  publishDate,
  onClose,
  uuid,
}) => {
  return (
    <>
      <LeftButton mode="outline" variant="black" onClick={onClose}>
        <CloseButton />
      </LeftButton>
      <TileActionText
        publishDate={publishDate}
        tileStatus={tileStatus}
        postId={postId}
        campaignContainer={campaignContainer}
        uuid={uuid}
      />
    </>
  );
};

CampaignPreviewFormMenu.propTypes = {
  campaignContainer: PropTypes.string,
  postId: PropTypes.number,
  tileStatus: PropTypes.string,
  publishDate: PropTypes.string,
  onClose: PropTypes.func,
  uuid: PropTypes.string,
};
